export default __webpack_public_path__ + "static/media/separacao.9af760a7.svg";